export default "__VITE_ASSET__DuX7Eaqz__"